import React from 'react';
import { makeCSS } from '../../utils/makeCSS';
import { Icon, IconProps } from './Icon';
import { Typography } from './Typography';
import { cx } from '@emotion/css';
import { SizeVariants } from '../../theme/themes';

export interface CardProps extends Pick<IconProps, 'icon'> {
  title: string;
  content: string;
  size?: SizeVariants.sm | SizeVariants.lg;
  onClick?: () => void;
}

const useCSS = makeCSS(({ theme }) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 16,
      border: `dashed 1px ${theme.color.line['02']}`,
      textAlign: 'center',
      padding: 32,
      boxSizing: 'border-box',
      background: theme.color.overlay.dark['01'],
      borderRadius: theme.borderRadius['2xl'],
      '&:hover': {
        background: theme.color.overlay.dark['02']
      }
    },
    'size-sm': {
      width: theme.spacing[60],
      height: theme.spacing[60]
    },
    'size-lg': {
      width: theme.spacing[80],
      height: theme.spacing[80]
    },
    clickable: {
      cursor: 'pointer'
    }
  };
});

export const Card = (props: CardProps) => {
  const { icon, title, size = 'sm', content, onClick } = props;

  const classes = useCSS();
  return (
    <div
      className={cx(
        classes[`size-${size}`],
        classes.root,
        !!onClick && classes.clickable
      )}
      onClick={onClick}
    >
      <Icon icon={icon} />
      <Typography colorVariant="02">{title}</Typography>
      <Typography colorVariant="02">{content}</Typography>
    </div>
  );
};
